import React from 'react';
import PropTypes from 'prop-types';
import { isFormatBillion } from '../helper';
import ChartContent from './ChartContent';
import { connect } from 'react-redux';
import memoized from 'fast-memoize';
import { REDUCER_NAME } from './../reducer';
import { ChartFooter } from '../../../common/chart/footer';
import { Translate } from 'react-redux-i18n';
import { getUnique } from './../../../helpers/Common';
import { customDataChart } from './../../../helpers/Chart';
import { LabelLeftRight } from '../../../common/chart/label';
import './chart-wrap.scss';

const CHART_HEIGHT = 200;
const CHART_HEAD_HEIGHT = 30;
const CHART_FOOTER_HEIGHT = 50;

const getMaxData = data => {
  const chartData = data.series || [];
  let max = 0;
  chartData.forEach(item => {
    max = Math.max(item.foreignBuyValue, item.foreignSellValue, max);
  });

  return max;
};

const getComputedMaxData = memoized(getMaxData);

class ChartWrap extends React.Component {
  state = {
    keyChart: getUnique(),
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      nextProps.component !== this.props.component ||
      nextProps.data !== this.props.data
    ) {
      this.setState({ keyChart: getUnique() });
    }
  }

  getHeight = () => {
    return CHART_HEIGHT + CHART_HEAD_HEIGHT + CHART_FOOTER_HEIGHT;
  };

  getLeftAxisTitle = () => {
    if (!isFormatBillion(this.getMaxData())) {
      return 'moneyFlowForeign.millionVnd';
    }

    return 'moneyFlowForeign.billion_vnd';
  };

  getMaxData = () => {
    const { data } = this.props;

    return getComputedMaxData(data);
  };

  render() {
    const {
      data: foreignData,
      component,
      isLoading,
      currentSearch,
    } = this.props;
    const { series: chartData = [] } = foreignData || {};
    const now = new Date();
    const formattedData = customDataChart(chartData, 'OneDay', 'foreign');
    const customChartData = currentSearch.isTicker
      ? formattedData.reduce((result, item, index) => {
          const tradingDate = new Date(item.tradingDate);
          const isNoData =
            item.foreignBuyValue === null && item.foreignSellValue === null;
          if (isNoData && now.getTime() > tradingDate.getTime() && index > 0) {
            return result.concat(result[index - 1]);
          }

          return result.concat(item);
        }, [])
      : formattedData;

    return (
      <div>
        {customChartData && customChartData.length > 1 ? (
          <div
            className="stock-chart position-relative border-radius-5 bg-t-color-2 chart-wrap"
            style={{ height: this.getHeight() }}
          >
            <LabelLeftRight text={this.getLeftAxisTitle()} />
            <div
              className="fs-12 font-weight-bold"
              style={{ height: CHART_HEAD_HEIGHT }}
            >
              <Translate value={'moneyFlowForeign.total_foreign_trading'} />
            </div>
            <div className="ml-20">
              <ChartContent
                isFormatBillion={isFormatBillion(this.getMaxData())}
                isTicker={currentSearch.isTicker}
                key={this.state.keyChart}
                data={customChartData}
                width={component.width - 70}
                height={CHART_HEIGHT}
                ratio={window.devicePixelRatio}
              />
            </div>
            <div style={{ height: CHART_FOOTER_HEIGHT }}>
              <ChartFooter
                list={[
                  {
                    text: 'moneyFlowForeign.foreign_buy',
                    color: '#009cff',
                    type: 'circle',
                  },
                  {
                    text: 'moneyFlowForeign.foreign_sell',
                    color: '#ffc859',
                    type: 'circle',
                  },
                  {
                    text: 'moneyFlowForeign.net_foreign',
                    color: '#1d97ef',
                    type: 'half-circle',
                    color2: '#eb505a',
                  },
                ]}
              />
            </div>
          </div>
        ) : (
          !isLoading && <Translate value={'common.NO_DATA'} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state[REDUCER_NAME].foreign.data,
    isLoading: state[REDUCER_NAME].foreign.isLoading,
    component: state[REDUCER_NAME].component,
    currentSearch: state[REDUCER_NAME].foreign.currentSearch,
  };
};

ChartWrap.propTypes = {
  data: PropTypes.object,
  component: PropTypes.object,
};

ChartWrap.defaultProps = {
  data: [],
  component: {},
};

export default connect(mapStateToProps)(ChartWrap);
